import searchTypes from '../models/searchTypes'
import storageService from '../Infrustructure/localStorageService'

let searchHistoryService = {
    setHistory: function (name, val) {
        storageService.setItem(name, JSON.stringify(val))
    },

    getHistory: function (name) {
        let val = storageService.getItem(name)
        if (val) {
            return JSON.parse(val)
        }
    },

    removeAll: function () {
        let vals = Object.values(searchTypes)
        vals.forEach(element => {
            storageService.removeItem(element)
        });
    },
    removeBesides: function (name) {     
        let vals = Object.values(searchTypes)
        vals.forEach(element => {
            if(name!==element)
            storageService.removeItem(element)
        });
    },
    removeHistory: function (name) {
        storageService.removeItem(name)
    }
};

export default searchHistoryService;




// WEBPACK FOOTER //
// ./src/services/searchHistoryService.js